import React, { useEffect, useState } from "react";
import {
  Table,
  Tooltip,
  Button,
  Form,
  Input,
  message,
  Select,
  Modal,
  Popconfirm,
  Image,
  Upload,
} from "antd";
import {
  EditOutlined,
  DeleteOutlined,
  SearchOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import axios from "axios";
import { SERVER_ADDRESS } from "../../../Config/Config";
const { Option } = Select;

const StlyeList = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [ismodalOpen, setIsmodalOpen] = useState(false);
  const [record, setRecord] = useState(null);
  const [form] = Form.useForm();
  const [fileList, setFileList] = useState([]);
  const [imageBase64, setImageBase64] = useState(null);
  const [isImageEdited, setIsImageEdited] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredData, setFilteredData] = useState([]);

  const handleSearch = (e) => {
    const searchValue = e.toLowerCase();
    // setSearchTerm(searchValue);
    setFilteredData(
      data.filter((item) => item.style_name.toLowerCase().includes(searchValue))
    );
  };

  const getBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const handleImageChange = async ({ fileList: newFileList }) => {
    setFileList(newFileList);
    if (newFileList.length > 0 && newFileList[0].originFileObj) {
      const base64 = await getBase64(newFileList[0].originFileObj);
      setImageBase64(base64);
      setIsImageEdited(true);
    } else {
      setImageBase64(null);
      setIsImageEdited(true);
    }
  };

  const onPreview = async (file) => {
    let src = file.url;
    if (!src && file.originFileObj) {
      src = await getBase64(file.originFileObj);
    }
    const image = new Image();
    image.src = src;
    const imgWindow = window.open(src);
    imgWindow?.document.write(image.outerHTML);
  };

  useEffect(() => {
    handleSearch(searchTerm);
  }, [searchTerm, data]);

  const columns = [
    {
      title: "Id",
      dataIndex: "style_id",
      sorter: "true",
      sorter: (a, b) => a.style_id - b.style_id,
      width: "10%",
      key: "style_id",
    },
    {
      title: "Style Name",
      dataIndex: "style_name",
      sorter: (a, b) => a.style_name.localeCompare(b.style_name),
      width: "10%",
      key: "style_name",
    },
    {
      title: "Search Key",
      dataIndex: "style_search_key",
      width: "10%",
      key: "style_search_key",
      render: (text) => {
        const displaysearchkey =
          text.length > 15 ? `${text.slice(0, 15)}...` : text;
        return text.length > 15 ? (
          <Tooltip title={text}>
            <span>{displaysearchkey}</span>
          </Tooltip>
        ) : (
          <span>{text}</span>
        );
      },
    },
    {
      title: "Customize",
      dataIndex: "is_customize",
      width: "10%",
      key: "is_customize",
      render: (record) => {
        if (record == 1) {
          return <p>Yes</p>;
        } else {
          return <p>No</p>;
        }
      },
    },
    {
      title: "Style Image",
      width: "20%",
      key: "style_image",
      render: (_, record) => (
        <>
          {record.style_image ? (
            <Image src={record.style_image} />
          ) : (
            <Image src="https://placehold.co/600x400" />
          )}
        </>
      ),
    },
    {
      title: "Options",
      width: "10%",
      key: "option",
      render: (_, record) => (
        <div style={{ display: "flex", gap: "8px" }}>
          <Tooltip title="Edit">
            <Button
              type="primary"
              onClick={() => handleEdit(record)}
              icon={<EditOutlined />}
            ></Button>
          </Tooltip>
          <Tooltip title="Delete">
            <Popconfirm
              placement="bottom"
              title="Delete Category"
              description="Are you sure to delete category ?"
              onConfirm={() => handleDelete(record.style_id)}
              okText="Yes"
              cancelText="No"
            >
              <Button danger icon={<DeleteOutlined />}></Button>
            </Popconfirm>
          </Tooltip>
        </div>
      ),
    },
  ];

  const fetchStyles = async (pagination) => {
    setLoading(true);
    try {
      const response = await axios.get(`${SERVER_ADDRESS}/api/style-list`);
      setData(response.data);
      setFilteredData(response.data);
      setLoading(false);
    } catch (error) {
      message.error({ content: "Internal server error", duration: 2 });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStyles();
  }, []);

  const handleEdit = (record) => {
    setRecord(record);
    setIsmodalOpen(true);
    form.setFieldsValue({
      style_name: record.style_name,
      style_search_key: record.style_search_key,
      is_customize: record.is_customize,
    });
    if (record.style_image) {
      setFileList([
        {
          uid: "-1",
          name: "current_image.png",
          status: "done",
          url: record.style_image,
        },
      ]);
      setImageBase64(record.style_image);
      console.log(fileList);
    }
  };

  // useEffect to watch fileList
  useEffect(() => {
    console.log("Updated fileList:", fileList);
  }, [fileList]);
  const handleCancel = () => {
    setIsmodalOpen(false);
    setRecord(null);
    setFileList([]);
    setImageBase64(null);
    setIsImageEdited(false);
  };
  const onFinish = async (values) => {
    try {
      const payload = {
        ...values,
        style_image: isImageEdited ? imageBase64 : record.style_image,
        isImageEdited,
      };
      const response = await axios.post(
        `${SERVER_ADDRESS}/api/update-style/${record.style_id}`,
        payload
      );
      if (response.status === 200) {
        message.success({ content: "Style updated successfully", duration: 2 });
        setIsmodalOpen(false);
        setRecord(null);
        fetchStyles();
      } else {
        message.error({ content: "Style cannot updated", duration: 2 });
      }
    } catch (error) {
      message.error({ content: "Internal server error", duration: 2 });
      console.log(error);
    }
  };
  const handleDelete = async (id) => {
    try {
      const response = await axios.post(
        `${SERVER_ADDRESS}/api/delete-style/${id}`
      );
      if (response.status === 200) {
        fetchStyles();
        message.success({ content: "Style deleted successfully", duration: 2 });
      } else {
        message.success({ content: "Style cannot deleted", duration: 2 });
      }
    } catch (error) {
      message.error({ content: "Internal server error", duration: 2 });
    }
  };
  const handleTablechange = () => {
    fetchStyles();
  };

  return (
    <div style={{ marginTop: "4rem" }}>
      <Input
        placeholder={"Search by style name"}
        prefix={<SearchOutlined />}
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        style={{ marginBottom: "1rem", width: "23%" }}
      />
      <Table
        columns={columns}
        dataSource={filteredData}
        rowKey="style_id"
        loading={loading}
        onChange={handleTablechange}
      ></Table>

      <Modal
        open={ismodalOpen}
        onCancel={handleCancel}
        footer={null}
        title={"Edit Style"}
      >
        <Form
          form={form}
          style={{
            backgroundColor: "white",
            width: "30rem",
            marginTop: "2rem",
            padding: "2rem",
            justifySelf: "center",
          }}
          labelCol={{ span: 8 }}
          wrapperCol={{ span: 14, offset: 1 }}
          onFinish={onFinish}
        >
          <Form.Item
            label="Style Name"
            name="style_name"
            rules={[
              { required: true, message: "Enter the style name" },
              {
                validator: (_, value) => {
                  if (value && value.trim().toLowerCase() === "image") {
                    return Promise.reject("Style name cannot be 'image'");
                  }
                  return Promise.resolve();
                },
              },
            ]}
          >
            <Input placeholder="Enter Category name"></Input>
          </Form.Item>
          <Form.Item
            label="Search Key"
            name="style_search_key"
            rules={[
              { required: true, message: "Enter the style search key name" },
            ]}
          >
            <Input placeholder="Enter search key"></Input>
          </Form.Item>
          <Form.Item
            label="Customize"
            name="is_customize"
            rules={[{ required: true, message: "Select the Customize Option" }]}
          >
            <Select placeholder="Select Customize">
              <Option value={1} key={1}>
                Yes
              </Option>
              <Option value={2} key={2}>
                No
              </Option>
            </Select>
          </Form.Item>
          <Form.Item
            label="Style Cover Image"
            name="style_image"
            rules={[
              {
                validator: async () => {
                  if (!imageBase64) {
                    return Promise.reject("Kindly Upload style Image");
                  }
                },
              },
            ]}
          >
            <Upload
              listType="picture-card"
              fileList={fileList}
              onChange={handleImageChange}
              showUploadList={{ showPreviewIcon: false }}
              beforeUpload={() => false}
            >
              {fileList.length >= 1 ? null : (
                <div>
                  <PlusOutlined />
                  <div style={{ marginTop: 8 }}>Upload</div>
                </div>
              )}
            </Upload>
          </Form.Item>

          <Form.Item
            wrapperCol={{
              offset: 10,
              span: 16,
            }}
          >
            <Button type="primary" htmlType="submit">
              Submit
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default StlyeList;
